import * as React from "react";
import { Route } from "react-router-dom";
import { Urls } from "./Urls";
import { Master } from "./General/Master";
import { Home } from "./General/Home";
import { DocumentSearch } from "./Reader/DocumentSearch";
import { DocumentView } from "./Reader/DocumentView";
import { Collections } from "./DocumentManagement/Collections";
import { Metas } from "./MetaManagement/Metas";
import { Translation } from "./MetaManagement/Translation";
import { Sync } from "./Sync/Sync";
import { LanguageSettingsEdit } from "./GlobalSettings/LanguageSettingsEdit";
import { BrandingEdit } from "./GlobalSettings/BrandingEdit";
import { Portals } from "./LocalSettings/Portals";
import { HtmlContent } from "./General/HtmlContent";
import { RecentFiles } from "./RecentFiles/RecentFiles";
import { MyFavourite } from "./Favourites/MyFavourite";
import { About } from "./General/About";
import { AppStore } from "./Stores/AppStore";

export const AppRoutes = () => {
	return <Master path={AppStore.history.location.pathname}>
		<Route exact path={Urls.home} component={Home} />
		<Route path={Urls.search} component={DocumentSearch} />
		<Route exact path={Urls.reader} component={DocumentSearch} />
		<Route exact path={Urls.reader + "/:file"} component={DocumentView} />
		<Route exact path={Urls.reader + "/:id/:lang/:file"} component={DocumentView} />
		<Route path={Urls.metas} component={Metas} />
		<Route path={Urls.portals} component={Portals} />
		<Route path={Urls.collections} component={Collections} />
		<Route path={Urls.sync} component={Sync} />
		<Route path={Urls.languages} component={LanguageSettingsEdit} />
		<Route path={Urls.branding} component={BrandingEdit} />
		<Route path={Urls.imprintUrl} component={HtmlContent} />
		<Route path={Urls.legalnoticeUrl} component={HtmlContent} />
		<Route path={Urls.privacypolicyUrl} component={HtmlContent} />
		<Route path={Urls.translation} component={Translation} />
		<Route path={Urls.recentFiles} component={RecentFiles} />
		<Route path={Urls.favorites} component={MyFavourite} />
		<Route path={Urls.about} component={About} />
	</Master>
}